// import Dexie from 'dexie';

// const db = new Dexie('CustomProductsDB');

// db.version(1).stores({
//   customers: '++id, sessionId',
//   products: '++id, customerId, productType, customizationInfo',
//   petsPeople: '++id, name, birthdate',
//   customerRelatedPetPerson: '++id, customerId, productId, petPersonId'
// });

// export default db;

import Dexie from 'dexie';

const db = new Dexie('CustomProductsDB');

db.version(1).stores({
  customers: '++id, sessionId',
  products: '++id, customerId, productType, customizationInfo',
  petsPeople: '++id, name, birthdate, *images',
  customerRelatedPetPerson: '++id, customerId, productId, petPersonId'
});

export default db;